import TicketHttp from "../../ticketHttp";

class DynamicServices {
// In your service file (MovieServices.js or similar)
static async getDynamicShowSchedules({ theatreName, movieId, theatreId }) {
    try {
        console.log('Params received in service:', { theatreName, movieId, theatreId });
         // Clean theatreId by trimming any unwanted characters (like '?')
       
        // Construct query string manually to ensure it's properly formatted
        const queryParams = [];
        if (theatreName) queryParams.push(`theatreName=${encodeURIComponent(theatreName)}`);
        if (movieId) queryParams.push(`movieId=${encodeURIComponent(movieId)}`);
        if (theatreId) queryParams.push(`theatreId=${encodeURIComponent(theatreId)}`);
        // if (date) queryParams.push(`date=${encodeURIComponent(date)}`);
        // if (showTime) queryParams.push(`showTime=${encodeURIComponent(showTime)}`);
        
        const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
        
        return await TicketHttp.get(`/movieShowSchedule/getDynamicShowSchedules${queryString}`);
    } catch (error) {
        console.error('Error in getDynamicShowSchedules:', error);
        throw error;
    }
}


static async getLatestSeatPricing({ theatreId,showtimeId, date, time }) {
    try {
        console.log('Params received in service:', { theatreId,showtimeId, date, time  });
         // Clean theatreId by trimming any unwanted characters (like '?')
       
        // Construct query string manually to ensure it's properly formatted
        const queryParams = [];
        if (theatreId) queryParams.push(`theatreId=${encodeURIComponent(theatreId)}`);
        if (showtimeId) queryParams.push(`showtimeId=${encodeURIComponent(showtimeId)}`);
       
        if (date) queryParams.push(`date=${encodeURIComponent(date)}`);
        if (time) queryParams.push(`time=${encodeURIComponent(time)}`);
        
        const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
        
        return await TicketHttp.get(`/movieShowSchedule/getLatestSeatPricing${queryString}`);
    } catch (error) {
        console.error('Error in getLatestSeatPricing:', error);
        throw error;
    }
}



static async getMasterSeatsLayout({ theatreId,movieId, date, showtimeId }) {
    try {
        console.log('Params received in service:getMasterSeatsLayout', { theatreId,movieId, date, showtimeId  });
         // Clean theatreId by trimming any unwanted characters (like '?')
       
        // Construct query string manually to ensure it's properly formatted
        const queryParams = [];
        if (theatreId) queryParams.push(`theatreId=${encodeURIComponent(theatreId)}`);
        // if (movieId) queryParams.push(`showtimeId=${encodeURIComponent(movieId)}`);
        if (movieId) queryParams.push(`movieId=${encodeURIComponent(movieId)}`);

       
        if (date) queryParams.push(`date=${encodeURIComponent(date)}`);
        if (showtimeId) queryParams.push(`showtimeId=${encodeURIComponent(showtimeId)}`);
        
        const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
        
        return await TicketHttp.get(`/master/layout${queryString}`);
    } catch (error) {
        console.error('Error in getMasterScreenLayout:', error);
        throw error;
    }
}


    static async createDynamicPrice({ theatreId, showtimeId, selectedDates, time, seatLayout, pricingType }) {
        // Construct the request body
        const requestBody = {
            theatreId,
            showtimeId,
            selectedDates,
            time,
            seatLayout,
            pricingType
        };

        // Send the POST request
        return TicketHttp.post("/dynamic/createDynamicPrice", requestBody);
    }





    static async getAllPricingDetails(theatreId){
        console.log('getAllPricingDetails theatreId',theatreId);
        const query = theatreId ? `?theatreId=${encodeURIComponent(theatreId)}` : '';
        return await TicketHttp.get(`/dynamic/getAllPricingDetails${query}`);
        // return TicketHttp.get('/dynamic/getAllPricingDetails');


    }


    static async updateDynamicPrice({ id, updates }) {
        return TicketHttp.update(`/dynamic/updateDynamicPrice/${id}`, updates);
    }
    

    static async deleteDynamicPrice({ id }) {
        return TicketHttp.delete(`/dynamic/deleteDynamicPrice/${id}`);
    }




    static async updateMasterSeatLayout({ layoutId, movieId,theatreId, seatLayout, date, showtimeId }) {
        try {
          if (!layoutId) throw new Error('layoutId is required');
      
          const payload = {
            movieId,
            theatreId,
            seatLayout,
            date,
            showtimeId,
          };
      
          console.log('Updating layout with:', payload);
      
          return await TicketHttp.update(`/master/layout/${layoutId}`, payload);
        } catch (error) {
          console.error('Error in updateMasterSeatLayout:', error);
          throw error;
        }
      }
    
}

export default DynamicServices;
